<template>
  <section>
    <header>
      <div class="col-td">Картка/Тримач</div>
      <div class="col-td">Дата</div>
      <div class="col-td">Послуга</div>
      <div class="col-td">Кількість</div>
      <div class="col-td">Ціна</div>
      <div class="col-td">СУМА (₴)</div>
      <div class="col-td text-align-end">ТО</div>
    </header>
    <div v-if="totalSum" class="table-row first-row">
      <div class="col-td">Вього</div>
      <div class="col-td"></div>
      <div class="col-td"></div>
      <div class="col-td">{{ totalAmount | toCurrency}}</div>
      <div class="col-td">{{ avgPrice | toCurrency }}</div>
      <div class="col-td">{{totalSum | toCurrency }}</div>
      <div class="col-td big text-align-end" style="width: 60%"></div>
    </div>

    <template  v-for="(tr, i) in transactions" >
      <div class="table-row" :key="i">
          <div class="col-td desktop" style="width: 15%">{{tr.cardNo}}<br>{{tr.cardOwner}}</div>
          <div class="col-td desktop" style="width: 15%">{{tr.transDate | formatDate}}</div>
          <div class="col-td desktop" style="width: 10%" >{{tr.goodName}}</div>
          <div class="col-td desktop"  style="width: 10%">{{tr.amount | toCurrency }}</div>
          <div class="col-td desktop"  style="width: 10%">{{tr.price | toCurrency }}</div>
          <div class="col-td desktop"  style="width: 10%">{{tr.transSum | toCurrency}}</div>
          <div class="col-td desktop big text-align-end" style="width: 30%">{{tr.station}}</div>
          <div @click="showMobile(tr)" class="col-td mobile" style="width: 60%"><span class="light-gray">{{tr.transDate | formatDateMob}}</span><br>{{tr.cardNo}}<br><span class="main-blue">{{tr.cardOwner}}</span></div>
          <div @click="showMobile(tr)"  class="col-td mobile" style="width: 40%; text-align: end">{{tr.transSum | toCurrency}}</div>
          <div @click="showTablet(tr)" class="col-td landscape" style="width: 10%"><span class="light-gray">{{tr.transDate | formatDateMob}}</span></div>
         <div @click="showTablet(tr)" class="col-td landscape" style="width: 25%;">{{tr.cardNo}}</div>
         <div @click="showTablet(tr)" class="col-td landscape" style="width: 25%;"><span class="main-blue">{{tr.cardOwner}}</span></div>
          <div @click="showTablet(tr)"  class="col-td landscape" style="width: 40%; text-align: end">{{tr.transSum | toCurrency}}</div>
      </div>

    </template>

  </section>
</template>
<script>
export default {
  name: "MainTransuction",
  props: {
    transactions: Array,
    totalSum: Number,
    totalAmount: Number,
    avgPrice: Number
  },
  methods: {
    showMobile: function (row) {
      this.$router.push({path: "trance-show", query: {transDate: row.transDate, goodName: row.goodName,transSum:row.transSum, price: row.price, amount: row.amount, station: row.station, cardNo: row.cardNo, cardOwner: row.cardOwner }} );
    },
    showTablet: function (row) {
      this.$router.push({path: "trance-show-tablet", query: {transDate: row.transDate, goodName: row.goodName,transSum:row.transSum, price: row.price, amount: row.amount, station: row.station, cardNo: row.cardNo, cardOwner: row.cardOwner }} );
    }
  }
}
</script>
<style>
.first-row {
  background-color: var(--strong-grey)!important;
  color: var(--usual-white)!important;
}

.table-row:nth-child(2n) {
  background-color: var(--soft-grey);
}
.table-row:hover {
  background-color: var(--active-purple);
}

section {
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 5px;
}

section > .table-row
{
  display: table-row;
  height: 64px;
  border-bottom:  1px solid var(--soft-grey);
}
section > header {
  display: table-row;
}
header > * {
  border-bottom: 3px solid var(--main-blue);
}
section header .col-td {
  vertical-align: bottom;
  padding-bottom: 10px;
  font-family: Roboto,arial,sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: var(--usual-black);
  letter-spacing: 1px;
}
section .col-td .big {
  width: 40%;
}
section .col-td {
  display: table-cell;
  //width: 20%;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  font-feature-settings: 'cpsp' on;
  padding: 0 6px;
  color: var(--usual-black);
}
.first-row .col-td  {
  font-weight: bold;
  color: var(--usual-white);
}
.col-td.mobile {
  display: none;
}
.col-td.landscape {
  display: none;
}
.light-gray {
  color: #535353;
}
.main-blue {
  color: var(--main-blue);
}

@media  (max-width: 1040px)  and (orientation: portrait) {
  section header{
   display: none;
  }
  .col-td.desktop {
    display: none;
  }
  section {
    margin-top: 25px;
  }

  .col-td.mobile {
    display: table-cell;
  }
  .table-row .col-td {
    padding: 15px;
  }
}
@media ( max-width: 1040px)  and (orientation: landscape) {
  section header{
    display: none;
  }
  .col-td.desktop {
    display: none;
  }
  section {
    margin-top: 25px;
  }
  .col-td.landscape {
    display: table-cell;
  }
  .table-row .col-td {
    padding: 15px;
  }
}
</style>